import React from 'react';
import CollectionReportFilters from './components/CollectionReportFilters';
import CollectionReportTable from './components/CollectionReportTable';
import useCollectionReportData from './hooks/useCollectionReportData';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportCollectionReportQuery } from '../../../api/endpoints/collectionReport';

const CollectionReportPage = () => {
    const { th } = useLanguage();
    const {
        rows,
        grandTotals,
        loading,
        exportParams,
        isDealerOnly,
        handleApplyFilters,
        handleResetFilters
    } = useCollectionReportData();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                <h1 className="m-0">{th('collectionReport.title') || 'Tahsilat Raporu'}</h1>

                <GenericFileExportButton
                    useExportQuery={useLazyExportCollectionReportQuery}
                    exportParams={exportParams}
                    buttonLabel={th('collectionReport.excelExport') || "Excel'e Aktar"}
                    buttonClassName="p-button-success"
                    icon="pi pi-file-excel"
                    defaultFileName="TahsilatRaporu"
                    dataExtractor={(result) => result?.fileBase64}
                    contentTypeExtractor={(result) => result?.contentType}
                    disabled={loading || !rows.length}
                />
            </div>

            <div className="mb-3">
                <CollectionReportFilters
                    onApply={handleApplyFilters}
                    onReset={handleResetFilters}
                    isDealerOnly={isDealerOnly}
                />
            </div>

            <CollectionReportTable rows={rows} grandTotals={grandTotals} loading={loading} />
        </div>
    );
};

export default CollectionReportPage;
